var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"navBar"},[_c('div',{on:{"click":function($event){return _vm.leftClick()}}},[_c('img',{attrs:{"src":require("../assets/ic_left.png"),"alt":""}})]),_c('p',[_vm._v(_vm._s(_vm.msg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }